import { render, staticRenderFns } from "./capture.vue?vue&type=template&id=99c90ab8&scoped=true&"
import script from "./capture.vue?vue&type=script&lang=js&"
export * from "./capture.vue?vue&type=script&lang=js&"
import style0 from "./capture.vue?vue&type=style&index=0&id=99c90ab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c90ab8",
  null
  
)

export default component.exports